<template>
  <el-dialog @open="open" :title="$t('CMSProduct.'+titleAction+'_'+title)" :visible.sync="visible" :close-on-click-modal="false">
    <el-form :model="model">
      <el-form-item v-for="l in cms_languages" :label="l.name" :key="l.id">
        <el-input v-model="model[l.code]"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Annuler</el-button>
      <el-button type="primary" @click="add">{{btnSave}}</el-button>
    </span>
  </el-dialog>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Label-dialog',
	props: {
		visible : {type : Boolean},
    edit: {type : Object},
    title : {type : String},
	},
  data() {
    return {
      newRegion :false,
      model : {
        fr : null,
        en : null,
      },
    };
  },components: {

  },
	methods: {
    add(){
      if(this.edit==null){
        this.$emit('add', this.model);
      }else{
        this.$emit('update', this.model);
      }
      this.close();
    },
    resetFields(){
      this.model = {
        fr : null,
        en : null,
      }
    },
    close(){
      this.$emit('close');
      this.resetFields();
    },
    open(){
      if(this.edit!=null){
        this.model.fr = this.edit.fr;
        this.model.en = this.edit.en;
      }
    },
    ...mapActions('controlData',['fetchLanguages'])
	},
	computed: {
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    btnSave(){
      return this.edit==null ? 'Ajouter' : 'Sauvegarder';
    },
    titleAction(){
      return this.edit==null ? 'add' : 'update';
    },
    ...mapState('controlData',['languages']),
	},
  created(){
    this.fetchLanguages()
  }
}
</script>
<style>
</style>
